<div class="track">

  @if (!isIndeterminate) {
    <div
      class="fill"
      [style.width.%]="percent"
      role="progressbar"
      aria-valuemin="0"
      [attr.aria-valuenow]="percent"
      aria-valuemax="100"
      [attr.aria-label]="ariaLabel">
    </div>
  }

  @if (isIndeterminate) {
    <div
      class="fill indeterminate"
      role="progressbar"
      aria-busy="true"
      [attr.aria-label]="label || 'Loading'">
    </div>
  }
</div>

@if (label || showFraction || showPercent) {
  <div class="label">
    @if (label) {
      {{ label }}
    }
    @if (!isIndeterminate) {
      @if (label && (showPercent || showFraction)) {
        <span>: </span>
      }
      @if (showFraction) {
        <span>{{ fractionText }}</span>
      }
      @if (showPercent && showFraction) {
        <span> ({{ percent }}%)</span>
      }
      @if (showPercent && !showFraction) {
        <span>{{ percent }}%</span>
      }
    }
  </div>
}
